module.exports = __webpack_public_path__ + "img/change.93406a44.png";